module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center loader"
  }, [_c('div', {
    staticClass: "loader__icon"
  }), _vm._v(" "), (_vm.message) ? _c('div', {
    staticClass: "loader__message",
    staticStyle: {
      "width": "100%",
      "font-size": "1rem!important"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.message) + "\n    ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/production/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-1fc989a6"}!/home/alarmplan/production/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading.vue
// module id = 1007
// module chunks = 1